import React from "react";
import parse from "html-react-parser";

const JournalPreviewInThread = ({ message }) => {
    // Check if message has journal data

    const isJournalShared = message?.journal?.isJournalShared &&
        message?.journal?.journal_keywords &&
        message?.journal?.user_journal_id &&
        message?.journal?.emotion_name;

    if (!isJournalShared) return null;

    // Format keywords for display
    const formatKeywords = (keywords) => {
        if (!keywords || !Array.isArray(keywords)) return "";
        return keywords.map(keyword =>
            keyword.charAt(0).toUpperCase() + keyword.slice(1)
        ).join(", ");
    };

    return (
        <div
            className="thread-journal-preview"
            style={{
                marginBottom: "16px",
                padding: "12px",
                // backgroundColor: "#1c2a37",
                borderRadius: "12px"
            }}
        >
            {/* Message Content */}
            <div style={{
                color: "#e6ecf1",
                marginBottom: "12px",
                fontSize: "16px"
            }}>
                {parse(message.content)}
            </div>

            {/* Journal Preview Box - Same Design, No Click */}
            <div style={{ width: "100%", marginTop: "8px" }}>
                <p style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#969FA7",
                    margin: "0 0 8px 0"
                }}>
                    User shared their {message.journal.emotion_name} reframe.
                </p>

                {/* Journal preview box - NO onClick, dimmed */}
                <div
                    style={{
                        backgroundColor: "#008CFF",
                        border: "2px solid white",
                        borderRadius: "14px",
                        padding: "12px 14px",
                        cursor: "default",
                        opacity: "0.9",
                    }}
                >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexDirection: "row"
                    }}>
                        {/* Keywords */}
                        <div style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#ffffff",
                            marginBottom: "8px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px"
                        }}>
                            {message?.journal?.title_answer ? parse(message.journal.title_answer) : 'NA'}
                        </div>

                        {/* Arrow Icon - Dimmed to show it's not clickable */}
                        <img
                            alt="arrow-icon"
                            src="/icons/arrow-square-right.svg"
                            style={{
                                width: "18px",
                                height: "18px",
                                opacity: "0.5"
                            }}
                        />
                    </div>
                </div>

                {/* Optional context text */}
                <p style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#666",
                    margin: "8px 0 0 0",
                    fontStyle: "italic"
                }}>
                    (View full journal details in the main chat)
                </p>
            </div>
        </div>
    );
};

export default JournalPreviewInThread;
